import {Post} from "Core/Controls/RssFeed/Models/Post";
import { deserialize, deserializeAs } from "libs/cerialize";

export class RssFeedModel {
	@deserialize
	Title: string;
	
	@deserializeAs(Post)
	Posts: Array<Post>;
}